import React from 'react';

import { SidebarContext } from './SidebarContext';

import type { PropsWithChildren } from 'react';

export const SidebarProvider = (props: PropsWithChildren) => {
	const refObject = React.useRef<HTMLDivElement>(null);
	return (
		<SidebarContext.Provider value={{ ref: refObject }}>
			{props.children}
		</SidebarContext.Provider>
	);
};
